import React, { useState, useEffect } from 'react';

import './index.module.less';

import { Confirm } from '@views/components/ConfirmModal';


interface IProps {
  repeatData: number[];
  onClose: () => void;
  onConfirm: (data: number[]) => void;
}

const ClassDisableSelfRepeat = (props: IProps) => {
  const [repeatDays, setRepeatDays] = useState<number[]>([0, 1, 2, 3, 4]);

  const renderItems = () => {
    const toggleDay = (index: number) => {
      if (repeatDays.includes(index)) {
        const newData = repeatDays.filter(day => day !== index);
        setRepeatDays(newData);
      } else {
        const newData = [...repeatDays, index];
        newData.sort();
        setRepeatDays(newData);
      }
    }

    const items = [
      "周一", 
      "周二", 
      "周三", 
      "周四", 
      "周五", 
      "周六", 
      "周日" 
    ].map((day, index) => {
      return (
        <div key={index} className='flex' styleName='row' onClick={() => toggleDay(index)}>
          <p>{day}</p>
          {repeatDays.includes(index) ? 
            <i className="iconfont icon-chenggong" styleName="icon-checked" /> :
            <span styleName='icon-unchecked'></span>
          }
        </div>
      )
    })
    return (
      <div className='flex' styleName='container'>{items}</div>
    );
  }

  const onConfirmClicked = () => {
    props.onConfirm && props.onConfirm(repeatDays);
    props.onClose && props.onClose();
  }

  useEffect(() => {
    setRepeatDays(props.repeatData || [0, 1, 2, 3, 4]);
  }, [props.repeatData]);

  return (
    <Confirm
        title="重复"
        confirmTheme="primary"
        cancelBtnText="取 消"
        confirmBtnText="确 定"
        showCancelBtn
        onCancel={props.onClose}
        ContentWidget={renderItems()}
        onConfirm={onConfirmClicked}
      />
  )
}

export default ClassDisableSelfRepeat;